var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('ktv-breadcrumb',{attrs:{"folder":_vm.$t('Loan', 'Loan'),"page":_vm.$t('Application', 'Application'),"title":_vm.$t('Loan Application List', 'Loan Application List')}}),_c('TablesGrid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }